'use strict'
module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-sanitize/index.js
// module id = 700
// module chunks = 95715928098905 168707334958949